import { Icon } from '@sdb/planning-ui';

// components styles
import { EntitySearchListItem } from '../../EntitySearch.styles';
import {
  EntityOptionColumn,
  EntityOptionRow
} from '../EntitySearchInput/EntitySearchInput.styles';

// types
import type {
  EntitySearchOption,
  UseEntityOptionColumnsReturnType
} from '../../EntitySearch.types';

type Column = UseEntityOptionColumnsReturnType[number];

type EntitySearchOptionItemProps = {
  props: React.HTMLAttributes<HTMLLIElement>;
  option: EntitySearchOption;
  columns: UseEntityOptionColumnsReturnType;
  isDebouncing: boolean;
  isSelected: boolean;
  multiple?: boolean;
};

function resolveColumnValue(col: Column, option: EntitySearchOption): unknown {
  const rawValue = option[col.key as keyof EntitySearchOption];
  if (col.valueFormatter) {
    return col.valueFormatter(rawValue as string | Date | undefined);
  }
  if (col.key === 'number' && !rawValue) {
    return option.number ?? option.entity?.number;
  }
  return rawValue;
}

export function EntitySearchOptionItem({
  props,
  option,
  columns,
  isDebouncing,
  isSelected,
  multiple
}: EntitySearchOptionItemProps) {
  return (
    <EntitySearchListItem {...props} disabled={isDebouncing}>
      <EntityOptionRow columnWidths={columns.map((col) => col.width)}>
        {columns
          .filter((col) => !col.hidden)
          .map((col) => (
            <EntityOptionColumn key={col.key}>
              {(resolveColumnValue(col, option) as React.ReactNode) ||
                (option[
                  col.key as keyof EntitySearchOption
                ] as React.ReactNode)}
            </EntityOptionColumn>
          ))}

        {multiple && (
          <EntityOptionColumn className="add-icon">
            <Icon
              type={isSelected ? 'check' : 'plus'}
              {...(isSelected && { sx: { color: 'primary.main' } })}
            />
          </EntityOptionColumn>
        )}
      </EntityOptionRow>
    </EntitySearchListItem>
  );
}
